module.exports = __webpack_public_path__ + "img/freevip1.0761204f.jpg";